import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Field } from 'formik';

import QuestionTypeSwitch from '../QuestionTypeSwitch/QuestionTypeSwitch';

class QuestionnaireFormField extends React.Component {
    constructor(props) {
        super(props);

        this.fieldRef = React.createRef();
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isActive && this.props.isActive) {
            const node = this.fieldRef.current;
            const nodePos = node.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const position = (window.pageYOffset + nodePos.top) -
                ((windowHeight - nodePos.height) / 2);
            window.scrollTo({
                top: position,
                left: 0,
                behavior: 'smooth',
            });
        }
    }

    render() {
        const {
            isActive,
            name,
            assessmentLanguage,
            ...other
        } = this.props;

        const questionClassName = classNames('questionnaire-form__item', {
            'questionnaire-form__item--active': isActive,
        });

        return (
            <div
                className={questionClassName}
                ref={this.fieldRef}
            >
                <Field
                    name={name}
                    render={fieldProps => (
                        <QuestionTypeSwitch
                            {...fieldProps}
                            {...other}
                            assessmentLanguage={assessmentLanguage}
                        />
                    )}
                />
            </div>
        );
    }
}

QuestionnaireFormField.propTypes = {
    isActive: PropTypes.bool,
    name: PropTypes.string.isRequired,
    assessmentLanguage: PropTypes.string.isRequired,
};

QuestionnaireFormField.defaultProps = {
    isActive: true,
};

export default QuestionnaireFormField;
